import querystring from 'querystring';
import { shouldUseProductionSettings } from 'src/utils/environment';

const APPLE_THIRD_PARTY_LOGIN_URL_PROD =
    'https://www.zocdoc.com/sso/apple/Signin?';
const APPLE_THIRD_PARTY_LOGIN_URL_DEV = '/sso-login';

const COGNITO_APP_CLIENT_ID_PROD = '49kc2qv54lh8tou2neso76nddp';
const COGNITO_THIRD_PARTY_LOGIN_URL_PROD =
    'https://verify.zocdoc.com/oauth2/authorize?redirect_uri=https%3A%2F%2Fwww.zocdoc.com%2Fapi%2Frest%2Faccounts%2Fv1%2Fsociallogin&response_type=code';

const COGNITO_APP_CLIENT_ID_DEV = '3nkh359ndcn1lous18qjnaed88';
const COGNITO_THIRD_PARTY_LOGIN_URL_DEV = '/sso-login';

export const getSSOLoginUrl = (provider, location = {}) => {
    let hostname = location.hostname || null;

    if (typeof window !== 'undefined') {
        hostname = window.location.hostname;
    }
    switch (provider) {
        case 'Facebook':
        case 'Google': {
            const cognitoClientId = shouldUseProductionSettings(hostname)
                ? COGNITO_APP_CLIENT_ID_PROD
                : COGNITO_APP_CLIENT_ID_DEV;
            const cognitoThirdPartyLoginUrl = shouldUseProductionSettings(
                hostname
            )
                ? COGNITO_THIRD_PARTY_LOGIN_URL_PROD
                : COGNITO_THIRD_PARTY_LOGIN_URL_DEV;

            const queryParam = {
                client_id: cognitoClientId,
                identity_provider: provider,
            };
            return `${cognitoThirdPartyLoginUrl}&${querystring.stringify(
                queryParam
            )}`;
        }
        case 'Apple': {
            const hostname = location.hostname || null;
            return shouldUseProductionSettings(hostname)
                ? APPLE_THIRD_PARTY_LOGIN_URL_PROD
                : APPLE_THIRD_PARTY_LOGIN_URL_DEV;
        }
        default: {
            break;
        }
    }
};
